import { alpha } from "@mui/material/styles";

// 용어 사전 화면의 테넌트 값 구분(변경/추가/제외) 색. 색을 바꿀 때는 여기 한 곳만 고친다.
//   변경 = 제품색(primary, 청록). 추가 = 제품 차트 팔레트(color-util PRESET_PALETTES calm)의 올리브 —
//   청록과 색상이 갈리고, success(성공·정상, 제품 전체에서 "OK" 뜻)의 초록과도 구분된다. 제외 = warning
//   dark = 글자·배지 바탕용 중간 톤(흰 글자 대비 약 4.2:1 — 변경 배지(청록 약 4:1)와 밝기를 맞춘다)
export const TERM_TONE = {
  override: { palette: "primary" },
  added: { main: "#7E9A3E", dark: "#6B8534", badge: "#6B8534" },
  excluded: { palette: "warning" },
};

// 테마 팔레트 키면 테마에서, 아니면 고정값 — sx 안에서 테마를 받아 푸는 형태
const tone = (key, th) => {
  const t = TERM_TONE[key];
  return t.palette ? th.palette[t.palette] : t;
};

export const toneMain = (key) => (th) => tone(key, th).main;
export const toneBadge = (key) => (th) => tone(key, th).badge || tone(key, th).main;
export const toneDark = (key) => (th) => tone(key, th).dark;
export const toneLight = (key) => (th) => alpha(tone(key, th).main, 0.1);
export const toneTint = (key, a) => (th) => alpha(tone(key, th).main, a);
